export function TemplateUpload() {
  return (
    <v-btn>
      <v-icon>mdi-upload-outline</v-icon>
    </v-btn>
  );
}

import ExampleHelpButton from '../example-buttons/ExampleHelpButton.vue';
import SectionHelp from '../templates/SectionHelp.mdx';

# Templates Page

This page is where you can Add, Remove, Edit or Delete Templates

<SectionHelp />

## Upload an Template

Click the <TemplateUpload /> button (top left) to upload an Template.
{/* Editor note: */}
{/* What formats does this accept? */}

## Search

If you start typing here, only the items that match your search terms will be shown.
